import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SettingIcon } from 'assets/svg';
import { useAppSelector } from 'features/app/hooks';
import { DialPadSettingsMenuButton } from 'features/dial-pad/components';
import { SelfViewSettingsMenuButtonContainer } from 'features/local-video/components';
import { MenuIconButton, MenuPopoverOld } from 'features/menu/components';
import { usePopover } from 'features/menu/hooks';
import { isZoomConferenceSelector } from 'features/call/call-conference/store';

export const SettingsMenuButtonContainer: FC = () => {
  const { t } = useTranslation();
  const popover = usePopover('menu-settings');
  const isZoomConference = useAppSelector(isZoomConferenceSelector);

  return (
    <>
      <MenuIconButton
        title={t('menuSettings')}
        icon={<SettingIcon />}
        isDisabled={false}
        isChecked={false}
        isCheckIconVisible={false}
        onClickHandler={popover.handleShowPopover}
        aria-describedby={popover.popoverId}
        testId='settings-menu-button'
      />
      <MenuPopoverOld popover={popover}>
        <SelfViewSettingsMenuButtonContainer />
        {!isZoomConference && <DialPadSettingsMenuButton />}
      </MenuPopoverOld>
    </>
  );
};
